<template>
    <div class="formSignIn">
        <img src="../../assets/images/auth/lock.png" class="lock d-none d-md-block" alt="Billede m. hængelås">
        <p class="greeting">Hej!</p>
        <p class="description">Indtast venligst dit elev-id</p>

        <form v-on:submit.prevent v-on:submit="doLoginAttempt">
            <input type="email" placeholder="Indtast e-mail" v-model="email">
            <input type="password" placeholder="Indtast adgangskode" v-model="password">

            <button type="submit" class="btn">
                <span v-if="isLoading"><div class="loader mx-auto"></div></span>
                <span v-else>Log på</span>
            </button>
        </form>
    </div>
</template>


<script>
export default {
    name: 'LoginForm',

    data: function() {
        return {
            email: '',
            password: '',

            isLoading: false,
        }
    },

    methods: {
        doLoginAttempt() {
            this.isLoading = true;
            this.$auth.login({
                url: '/auth/login',
                success: function(res) {
                    console.log('Successfully authenticated');
                },
                error: function(error) {
                    if(error.response.status === 403) {
                       this.$notify({
                            group: 'main',
                            type: 'error',
                            title: 'Abonnement ophørt',
                            text: 'Du adgang blev nægtet da køreskolens abonnement er ophørt. Kontakt din kørelærer.',
                            duration: 10000,
                        }); 
                    }
                    else {
                        this.$notify({
                            group: 'main',
                            type: 'error',
                            title: 'Ugyldigt login',
                            text: 'Prøv at logge på igen.',
                        });
                    }
                    this.isLoading = false;
                },
                data: {email: this.email, password: this.password},
                redirect: 'appointments',
                fetchUser: true,
            });
        }
    }
}
</script>
